<template>
  <div class="c-description description">
    <h3
      class="description__title"
      data-anim="title"
    >
      {{ data.title }}
    </h3>
    <p
      v-for="(paragraph, i) in data.content"
      :key="i"
      data-anim="paragraph"
    >
      {{ paragraph }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppDescription',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

</style>
